import { LinkBoxList, Main } from 'ui/components';
import { ArticleHeader, ArticleByline, ArticleAuthor } from 'ui/components/2-molecules/Article';
import { Container } from 'ui/components/4-habitats/Container';
import { ModuleMapFeature } from 'features/Mappers/Module';
import { useDynamicNavigationLinks } from '../shared/useDynamicNavigationLinks';

export const ArticlePageFeature: React.FC<Umbraco.ArticlePage> = ({ properties }) => {
	const { author, pageSections, pageSettings } = properties ?? {};
	const { useDynamicNavigation, dynamicLinks, heading } = useDynamicNavigationLinks(pageSettings);
	const lastSection = pageSections?.[pageSections.length - 1];
	const linkBoxSectionWidth = lastSection?.settings?.properties?.width || 'Standard';
	return (
		<Main>
			<Container width="Small">
				<ArticleHeader {...properties} />
				{author && <ArticleByline {...author?.properties} />}
			</Container>
			{pageSections.map((pageSection, index) => (
				<ModuleMapFeature key={index} contentModule={pageSection} />
			))}
			<Container width="Small">{author && <ArticleAuthor {...author?.properties} />}</Container>
			{useDynamicNavigation && dynamicLinks.length > 0 && (
				<LinkBoxList
					items={[{ heading, links: dynamicLinks, variant: 'inline' }]}
					desktopWidth="100"
					mobileWidth="100"
					containerWidth={linkBoxSectionWidth}
				/>
			)}
		</Main>
	);
};
